module.exports = __webpack_public_path__ + "account/img/211.08973b53.png";